import DelegationType from '@/ecm/variables/DelegationType';

export default class Delegation {
    constructor(dto) {
        this.id = 0;
        this.description = '';
        this.startDate = '';
        this.endDate = '';
        this.delegatorUserId = null;
        this.users = [];
        this.type = DelegationType.Manual;

        if (dto) {
            this.id = dto.id;
            this.description = dto.description;
            this.startDate = dto.startDate;
            this.endDate = dto.endDate;
            this.type = dto.startDate ? DelegationType.Scheduled : DelegationType.Manual;
            this.delegatorUserId = dto.delegatorUserId;
            this.users = dto.delegatedUserIds.map(function (id) { return { id: id + '', text: '' }; });
        }
    }

    toDto() {
        return {
            Id: this.id,
            Description: this.description,
            StartDate: this.startDate,
            EndDate: this.endDate,
            DelegatorUserId: this.delegatorUserId,
            DelegatedUserIds: this.users.map(item => parseInt(item.id)),
        };
    }
}
